import { RULE_TYPES, PLACEMENTS } from './ruleConstants'

const PLACEMENT_LABEL_ALIASES = {
  search_boost: 'Search boost',
}

export function parseJsonField(value, fallback = {}) {
  const text = String(value || '').trim()
  if (!text) return fallback
  return JSON.parse(text)
}

export function formatJson(value) {
  return JSON.stringify(value || {}, null, 2)
}

export function formatDate(value) {
  if (!value) return '-'
  return new Date(value).toLocaleString()
}

export function formatDateTimeLocal(value) {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  return local.toISOString().slice(0, 16)
}

export function toIsoDateTime(value) {
  const text = String(value || '').trim()
  if (!text) return null
  const date = new Date(text)
  return Number.isNaN(date.getTime()) ? null : date.toISOString()
}

export function formatRuleType(value) {
  return RULE_TYPES.find((option) => option.value === value)?.label || value
}

export function formatPlacement(value) {
  return PLACEMENTS.find((option) => option.value === value)?.label || PLACEMENT_LABEL_ALIASES[value] || value
}

export function parseTags(value) {
  return String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

export function pickFirstText(...values) {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim()
    if (Array.isArray(value) && value.length) return String(value[0] || '').trim()
  }
  return ''
}

export function pickFirstList(...values) {
  for (const value of values) {
    if (Array.isArray(value) && value.length) return value.join(', ')
    if (typeof value === 'string' && value.trim()) return value.trim()
  }
  return ''
}

export function numberOrEmpty(value) {
  return value === null || value === undefined || value === '' ? '' : String(value)
}

export function listToText(value) {
  if (Array.isArray(value)) return value.join(', ')
  return ''
}

export function numericOrNull(value) {
  const text = String(value ?? '').trim()
  if (!text) return null
  const number = Number(text)
  return Number.isFinite(number) ? number : null
}

export function itemIsActive(item) {
  return item?.is_active !== false
}

export function itemInActiveWindow(item) {
  const now = Date.now()
  if (!itemIsActive(item)) return false
  if (item.starts_at && new Date(item.starts_at).getTime() > now) return false
  if (item.ends_at && new Date(item.ends_at).getTime() <= now) return false
  return true
}

export function statusIsRuntimeActive(status) {
  const value = String(status || '').toLowerCase()
  return !value || ['active', 'enabled', 'live'].includes(value)
}
